import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import teamMembers from '../commons/utils/team-members';
import Input from '../commons/component/input';
import InputNumber from '../commons/component/input-number';
import Button from '../commons/component/button';
import Error, { hasNamedError } from '../commons/component/error';
import retrievePassword from '../api/account/password-retrieval.js';
// import Recaptcha from '../commons/component/captcha/recaptcha';
import AempUserIcon from '../icons/aemp-user-icon';
import { dispatchMetric } from '../metrics';
import { getEventPayload } from '../metrics/metrics.selector';

class EsqueciSenhaComponent extends Component {
  state = {
    teamMember: teamMembers(),
    email: '',
    CNPJ: '',
    isFormSubmitting: false,
    isFormSubmittedSuccessfully: false,
    errors: {}
  };

  renderFooter() {
    const { isFormSubmittedSuccessfully } = this.state;

    return (
      <div className="esqueciSenha-footer">
        <div className="button-group">
          <Button
            disabled={this.state.isFormSubmitting}
            loading={this.state.isFormSubmitting}
            onClick={() => (window.location.pathname = '/simple-login/esqueci-senha')}
            className="cadastroForm-submit clear-button"
          >
            Voltar
          </Button>
          {!isFormSubmittedSuccessfully ? (
            <Button
              primary
              disabled={this.state.isFormSubmitting}
              loading={this.state.isFormSubmitting}
              className="cadastroForm-submit button-continue"
            >
              Continuar
            </Button>
          ) : (
            <Button
              primary
              onClick={() => (window.location.pathname = 'simple-login/')}
              className="cadastroForm-submit button-continue"
            >
              Continuar
            </Button>
          )}
        </div>
        <p className="help-message">
          está tendo dificuldade para entrar?{' '}
          <a
            href="/hotsite/empresas-site-atendimento"
            onClick={() =>
              dispatchMetric('event_login', {
                payload: getEventPayload({
                  event: 'event_login',
                  eventCategory: 'tela-login',
                  eventAction: 'preciso-de-ajuda',
                  eventLabel: undefined
                })
              })
            }
          >
            preciso de ajuda
          </a>
        </p>
      </div>
    );
  }

  render() {
    if (this.state.isFormSubmittedSuccessfully) {
      return (
        <div id="results">
          <div className="esqueciSenhaForm-container">
            <h2 className="cadastroForm-title">
              <AempUserIcon />
              <span>lembrete de senha</span>
            </h2>

            <div className="message-success">
              <p>tudo certo! enviaremos um e-mail com as informações.</p>

              <p>
                é importante que você tenha acesso e confira sua caixa de entrada e caixa de spam.
                caso não receba o e-mail após 48h,{' '}
                <a href="/hotsite/empresas-site-atendimento">entre em contato conosco.</a>
              </p>

              <p>
                caso os dados informados não estejam registrados em nosso sistema, crie um novo
                login e senha para continuar.
              </p>
            </div>
            {this.renderFooter()}
          </div>
        </div>
      );
    }

    return (
      <div className="esqueciSenhaForm-container">
        <h2 className="cadastroForm-title">
          <AempUserIcon />
          <span>lembrete de senha</span>
        </h2>

        <p className="">
          informe o CNPJ da empresa e o e-mail da conta. um link será enviado para alterar sua
          senha.
        </p>

        <form className="cadastroForm esqueci-senha" onSubmit={this.sendForm.bind(this)}>
          <div className="inputGroupDiv">
            <div className="inputGroup  --withScore" id="new-password">
              <label className="inputGroup-label" htmlFor="new-password-input">
                CNPJ
              </label>
              <InputNumber
                name="cnpj"
                id="cnpj-input"
                data-page="cnpj"
                data-form="cnpj"
                onChange={this.changeCNPJ.bind(this)}
                value={this.state.CNPJ}
                className="inputGroup-input --large round-input"
                size="14"
                maxLength="14"
                minLength="14"
                type="text"
                mask="__.___.___/____-__"
                placeholder="__.___.___/____-__"
                required
              />
            </div>

            <div className="inputGroup --withScore" id="email-input">
              <label className="inputGroup-label" htmlFor="email-input">
                e-mail
              </label>
              <Input
                name="email"
                id="email-input"
                data-form="forgot"
                data-page="forgot"
                type="email"
                onChange={this.changeEmail.bind(this)}
                value={this.state.email}
                className="inputGroup-input --large round-input"
              />
            </div>
          </div>

          {/* {config.enableCaptchaOnChangePassword && <Recaptcha ref={ref => (this.captcha = ref)} />} */}

          {this.renderFooter()}
          <Error errors={this.state.errors} name="errorMessage" />
        </form>
      </div>
    );
  }

  async sendForm(evt) {
    try {
      evt.preventDefault();
      this.setState({ isFormSubmitting: true });

      // const { token } = getAllQueryParams();
      // const captchaResponse = config.enableCaptchaOnChangePassword
      //   ? await this.captcha.getResponse()
      //   : '';

      const { errors } = {};
      // const { errors } = await changePassword(this.state.newPassword, token, captchaResponse);

      if (errors) {
        console.log('errors');
        throw errors;
      } else {
        retrievePassword(this.state.email).then(() =>
          this.setState({ isFormSubmittedSuccessfully: true, isFormSubmitting: false })
        );
      }
    } catch (errors) {
      console.log('errors');
      console.error(errors);
      // if (errors !== 'request timeout' && config.enableCaptchaOnChangePassword) {
      //   this.captcha.reset();
      // }

      this.setState({ errors, isFormSubmitting: false });
    }
  }

  hasError(name) {
    return hasNamedError(name, this.state.errors) ? '--hasError' : '';
  }

  changeCNPJ(e) {
    const CNPJ = e.target.value;
    this.setState({
      CNPJ
    });
  }

  changeEmail(e) {
    const email = e.target.value;
    this.setState({
      email
    });
  }
}

class EsqueciSenhaContainer extends React.Component {
  render() {
    return (
      <Switch>
        <Route
          path="/esqueci-senha"
          children={() => <EsqueciSenhaComponent history={this.props.history} />}
        />
        <Redirect to="/esqueci-senha" />
      </Switch>
    );
  }
}

export default withRouter(EsqueciSenhaContainer);
